module App.Interfaces {
    export interface ICategoryGroup {
        sort: number;
        name: string;
        description: string;
        subcategories: string[];
    }
}